export const DUMMY_CAR_IMAGES: string[] = [
  "https://images.unsplash.com/photo-1542362567-b07e54358753?auto=format&fit=crop&w=1200&q=70",
  "https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=1200&q=70",
  "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?auto=format&fit=crop&w=1200&q=70",
  "https://images.unsplash.com/photo-1525609004556-c46c7d6cf023?auto=format&fit=crop&w=1200&q=70",
  "https://images.unsplash.com/photo-1511919884226-fd3cad34687c?auto=format&fit=crop&w=1200&q=70",
  "https://images.unsplash.com/photo-1541899481282-d53bffe3c35d?auto=format&fit=crop&w=1200&q=70",
  "https://images.unsplash.com/photo-1507136566006-cfc505b114fc?auto=format&fit=crop&w=1200&q=70",
  "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?auto=format&fit=crop&w=1200&q=70",
];

function clean(list?: any): string[] {
  if (!Array.isArray(list)) return [];
  return list
    .map((x) => (typeof x === "string" ? x.trim() : ""))
    .filter(Boolean);
}

/**
 * ✅ Dynamic normalize:
 * - Use images[] if present
 * - else use [imageUrl] if present
 * - else use dummy list (can be any length, here 8)
 */
export function normalizeCarImages(images?: string[], imageUrl?: string) {
  const arr = clean(images);
  if (arr.length) return arr;

  if (typeof imageUrl === "string" && imageUrl.trim()) return [imageUrl.trim()];

  return DUMMY_CAR_IMAGES; // only when there are no real images at all
}
